const mfaAndResetDeliveryOptionsTemplate = `
<div id="statementsDocs-spinner" class="loaderBackground just-element" ng-if="!mfa.dataLoaded">
    <div class="loader"></div>
</div>
<div ng-if="mfa.errorMessage != null" class="form-group has-error" id="screenReader" tabindex="0">
    <span class="help-block" translate="MFA_{{mfa.errorMessage}}" translate-default="We are unable to send verification codes at this time. Please try again. Contact a Participant Services Representative if the problem continues.">
    </span>
</div>
<div ng-if="emptyDeliveryOptionsMessage !== null" class="form-group has-error" id="screenReader" tabindex="0">
    <span class="help-block">{{emptyDeliveryOptionsMessage}}</span>
</div>
<div class="form-group" ng-if="mfa.dataLoaded">
    <label for="deliveryOption" class="control-label">Where should we send your code?</label>

    <div data-ng-show="internationalPhoneMessage !== null" class="alert alert-warning">
        <p>{{internationalPhoneMessage}}</p>
    </div>

    <span class="sr-only" id="deliveryOptionRules">{{"MFA_ActivationCodeDeliveryMissingInputException"| translate }}. </span>
    <select
         name="deliveryOption"
        class="form-control"
        id="deliveryOption"
        data-ng-init="activationCodeModel.deliveryOption='none'"
        data-ng-model="activationCodeModel.deliveryOption"
        data-ng-disabled="emptyDeliveryOptionsMessage !== null"
        ng-change="codeDeliveryChange(activationCodeModel.deliveryOption)"
        aria-describedby="deliveryOptionRules"
    >
        <option value="none">Choose delivery method</option>
        <option ng-repeat="option in mfa.deliverySet" ng-disabled= "internationalPhoneMessage !== null && option.deliveryPhoneType === 'IntlPhoneNumber'" value="{{option.deliveryType}}" aria-label="{{option.deliveryMask}}">   {{option.deliveryMask}}</option>
    </select>
</div>
<a ng-show="$state.current.name === 'loginHelpDeliveryOptions' && emptyDeliveryOptionsMessage == null"
   ui-sref="verifyCodeForLoginHelp"
   class="secondary-cta"
   ng-click="verifyCodeLoginHelp()"
>{{ "alreadyHasCode" | translate }}</a>
<a ng-show="$state.current.name === 'activationCodeDeliveryOptions' && emptyDeliveryOptionsMessage == null"
   ui-sref="verifyCode"
   class="secondary-cta"
   ng-click="verifyCode()"
>{{ "alreadyHasCode" | translate }}</a>


<div class="form-group clearfix" ng-if="mfa.dataLoaded">            
    <button type="submit" class="btn btn-primary btn-primary__accessible btn-lg btn-block margin-top-default outline-btn" ng-disabled="emptyDeliveryOptionsMessage !== null && showSpinner==true" id="deliveryOptionsContinue">
        <span data-ng-hide="showSpinner==true" id="deliveryOptionsContinueLabel">
            Send me a Code
        </span>
                                
        <span data-ng-show="showSpinner==true" id="deliveryOptionsContinueSpinner">
            <i class="fa fa-circle-o-notch fa-spin"></i>
            Processing ...
        </span>
    </button>
</div>

<div
    aria-live="{{activationCodeModel.alert === 'show'?'polite':'off'}}"
    class="text-notation form-details"
    ng-show="activationCodeModel.alert === 'show'"
    translate="sendActivationCodeAlert" ng-if="mfa.dataLoaded">
</div>
`;
export default mfaAndResetDeliveryOptionsTemplate;
